export { default as envConfig } from 'config/env.json';
